var module = angular.module('octopusApp.library');

module.controller('ActionTemplateLogoController', function ($scope, $location, $stateParams, busy, octopusRepository, octoUploader, octopusClient, $filter) {
    var id = $stateParams["id"];
    var octoUpload = octoUploader.create($scope);

    $scope.resolveLink = $filter('resolveLink');
    $scope.isLoading = busy.create();
    $scope.isUploading = busy.create();
    $scope.octoUpload = octoUpload;
    $scope.beginReset = beginReset;
    $scope.beginUpload = beginUpload;


    $scope.cancel = function () {
        octoUpload.cancel();

        var form = $("#logoUpload")[0];
        if (form) {
            form.reset();
        }
    };

    function init() {
        $scope.isLoading.promise(octopusRepository.ActionTemplates.get(id).then(onActionTemplateLoaded));
    }

    function beginUpload() {
        var url = octopusClient.resolve($scope.actionTemplate.Links['Logo']);
        $scope.isUploading.promise(octoUpload.begin(url).then(function () {
            $location.path('/library/steptemplates/' + $scope.actionTemplate.Id).search('activeTab', 'settings');
        }));
    }

    function beginReset() {
        $scope.isUploading.promise(octopusClient.put($scope.actionTemplate.Links['Logo'], null).then(function () {
            $location.path('/library/steptemplates/' + $scope.actionTemplate.Id).search('activeTab', 'settings');
        }));
    }

    function onActionTemplateLoaded(actionTemplate) {
        $scope.actionTemplate = actionTemplate;
    }

    init();
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/action_template_logo_controller.js
// module id = 6825938848595127
// module chunks = 1